"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ExperimentFileTypeMultiChoice = function ExperimentFileTypeMultiChoice(_ref) {
  var fileTypes = _ref.fileTypes,
    _onChange = _ref.onChange;
  var _useState = (0, _react.useState)(_lodash["default"].map(fileTypes, "id")),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFileTypes = _useState2[0],
    setSelectedFileTypes = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
    style: {
      listStyle: "none"
    }
  }, fileTypes.map(function (fileType, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: fileType.id,
      type: "checkbox",
      checked: selectedFileTypes.includes(fileType.id),
      onChange: function onChange() {
        var updatedSelectedFiletypes = _lodash["default"].xor(selectedFileTypes, [fileType.id]);
        setSelectedFileTypes(updatedSelectedFiletypes);
        _onChange(updatedSelectedFiletypes);
      }
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: fileType.id
    }, fileType.description));
  })), selectedFileTypes.length === 0 && /*#__PURE__*/_react["default"].createElement("p", {
    className: "small"
  }, "Please select at least one file type to start your download."));
};
ExperimentFileTypeMultiChoice.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  fileTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    id: _propTypes["default"].string
  })).isRequired
};
ExperimentFileTypeMultiChoice.defaultProps = {
  onChange: function onChange() {}
};
var _default = exports["default"] = ExperimentFileTypeMultiChoice;